module.exports = __webpack_public_path__ + "media/images/icons/flag-en-da81bd59639d5e687fd8124ae7948f90.svg";